import LogRocket from 'logrocket';
LogRocket.init('vgd7eb/clean-intel');

import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import { sync } from 'vuex-router-sync';

// Importing this here gets around a weird webpack double-inclusion issue
import downloader from '@/services/downloader';

import App from './App.vue';
import router from './router';
import store from './store';
import './plugins';
import vuetify from './plugins/vuetify';
import AppLayout from './layouts/AppLayout.vue';
import CenteredLayout from './layouts/CenteredLayout.vue';

import './filters/index';
import './services';
import './utils/permissions';

sync(store, router);

Vue.config.productionTip = false;

Vue.component('app-layout', AppLayout);
Vue.component('centered-layout', CenteredLayout);

Vue.use(AsyncComputed);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
